import React from 'react'

import {Colors, IconButton, Modal} from '../../src/components/UI/index.js'
import {formSpacing} from '../../src/components/UI/forms/index.js'

type ImageLightboxProps = {
    show: boolean
    image?: string
    onClose: () => void
    onRemove?: () => void
}

export default function ImageLightbox(props: ImageLightboxProps) {
    const {show, image, onClose, onRemove} = props

    return (
        <Modal
            show={show}
            onClose={onClose}
            closeOnBackdropClick
            style={{width: '90%', maxWidth: 1000}}
        >
            <div style={{display: 'flex', justifyContent: 'flex-end', gap: formSpacing.tight, marginBottom: 12}}>
                {onRemove &&
                    <IconButton onClick={onRemove} style={{background: Colors.backgroundNeutral2}}>
                        <i style={{color: Colors.buttonSolid}} className='mdi mdi-delete' />
                    </IconButton>
                }

                <IconButton onClick={onClose} style={{background: Colors.backgroundNeutral2}}>
                    <i style={{color: Colors.buttonSolid}} className='mdi mdi-close' />
                </IconButton>
            </div>

            <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', background: Colors.backgroundWhite, borderRadius: 6, padding: 8}}>
                {!!image &&
                    <img
                        src={image}
                        style={{
                            maxWidth: '100%',
                            maxHeight: '72vh',
                            objectFit: 'contain',
                            borderRadius: 6
                        }}
                    />
                }
            </div>
        </Modal>
    )
}
